import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { ErrorBoundary } from "./components/ErrorBoundary";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("缺少 #root");

createRoot(root).render(
  <StrictMode>
    <ErrorBoundary variant="page">
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
